import $ from 'jquery'

const SEARCH_OVERLAY_SELECTOR = '.search-overlay'
const SEARCH_TRIGGER_SELECTOR = '.search-toggle'
const SEARCH_OVERLAY_CLOSE_BTN_SELECTOR = '.search-overlay__close'

/*
 * Laufende Nummer fuer die ids der Vorschlaglisten.
 *
 * Eine Seite kann mehrere Suchformulare tragen, das Overlay im Kopf und das Feld der
 * Ergebnisseite. Beide laufen durch initAutocomplete(). aria-controls braucht je Liste
 * eine eigene id, eine fest verdrahtete waere auf der Ergebnisseite doppelt vergeben.
 */
let vorschlaglisteNummer = 0

class SearchOverlay {
  constructor() {
    this.searchOverlay = $(SEARCH_OVERLAY_SELECTOR)
    this.searchTriggers = $(SEARCH_TRIGGER_SELECTOR)
    this.overlayClostBtn = $(SEARCH_OVERLAY_CLOSE_BTN_SELECTOR)
    this.overlayActive = false
    this.init()
  }

  init() {
    this.initEventListener()
    this.initAutocomplete()
  }

  initEventListener() {
    this.searchTriggers.each((i, el) => {
      $(el).on('click', ev => {
        ev.preventDefault()
        ev.stopPropagation()
        if (this.overlayActive) {
          this.hide()
        } else {
          this.show()
        }
      })
    })

    this.overlayClostBtn.on('click', () => {
      this.hide()
    })

    this.searchOverlay.on('keydown', e => {
      if (e.key === 'Tab') {
        const focusableElements = this.searchOverlay
          .find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
          .filter(':visible')
        if (focusableElements.length === 0) {
          e.preventDefault()
          return
        }

        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus()
            e.preventDefault()
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus()
            e.preventDefault()
          }
        }
      } else if (e.key === 'Escape') {
        this.hide()
      }
    })

    $('body').on('tx_solr_updated', () => {
      this.initAutocomplete()
    })
  }

  show() {
    this.overlayActive = true
    this.searchOverlay.show()
    $(document.body).addClass('body-no-scroll')

    setTimeout(() => {
      const $searchInput = this.searchOverlay.find('#search')

      if ($searchInput.length > 0) {
        $searchInput[0].focus({ preventScroll: true })
      }
    }, 50)
  }

  hide() {
    this.overlayActive = false
    this.searchOverlay.hide()
    $(document.body).removeClass('body-no-scroll')
  }

  initAutocomplete() {
    $('form[data-suggest]').each(function() {
      var $form = $(this),
        $searchBox = $form.find('.tx-solr-suggest'),
        $formAutoComplete

      if ($form.find('.tx-solr-autocomplete').length > 0) {
        $formAutoComplete = $form.find('.tx-solr-autocomplete')
      } else {
        $formAutoComplete = $('body')
      }

      /*
       * Hier wird bewusst kein Fokus gesetzt.
       *
       * Die Zeile lief fuer jedes Suchformular der Seite. Auf der Ergebnisseite ist das
       * Feld sichtbar und bekam damit schon beim Laden den Fokus; die beiden Sprunglinks
       * lagen danach hinter dem Fokus und waren nur per Shift+Tab erreichbar
       * (Pruefschritt 9.2.4.1). Ueber tx_solr_updated lief sie ausserdem nach jeder
       * Aktualisierung der Trefferliste erneut.
       *
       * Das Overlay braucht sie nicht: show() fokussiert sein Feld selbst, und zwar erst,
       * wenn jemand das Overlay oeffnet. Der Fokus folgt damit einer Handlung.
       */

      // when no specific container found, use the form as container
      if ($searchBox.length === 0) {
        $searchBox = $form
      }
      $searchBox.css('position', 'relative')

      /*
       * Rollen fuer Hilfsmittel, Pruefschritt 9.4.1.2 und Verstoss #25 des Pruefberichts.
       *
       * Angesagt wird die Zahl der Vorschlaege bereits, dafuer sorgt der
       * aria-live-Announcer in transformResult. Was fehlte, war das Rollen-Geruest: Ohne
       * es ist das Suchfeld fuer einen Screenreader ein gewoehnliches Textfeld und die
       * Vorschlagliste keine Liste.
       *
       * $eingabefeld getrennt von $searchBox: Letzteres faellt oben auf das Formular
       * zurueck, wenn kein Feld gefunden wird. Ein Formular ist keine Combobox.
       */
      var $eingabefeld = $form.find('.tx-solr-suggest')
      var rollenAktiv =
        $eingabefeld.length > 0 && $formAutoComplete.length > 0 && !$formAutoComplete.is('body')

      if (rollenAktiv) {
        $eingabefeld.attr({
          role: 'combobox',
          'aria-autocomplete': 'list',
          'aria-expanded': 'false',
        })
      }

      /*
       * aria-controls wird erst in beforeRender gesetzt, nicht hier.
       *
       * Die Liste selbst baut die Bibliothek erst beim ersten Tippen, und zwar INNERHALB
       * von .tx-solr-autocomplete. Zeigt aria-controls auf den aeusseren Container, dann
       * verweist es auf ein Element ohne Rolle, und die eigentliche Listbox liegt eine
       * Ebene tiefer. Ein Verweis auf eine noch nicht vorhandene id waere ebenso falsch.
       * Deshalb erst dann, wenn es das Ziel wirklich gibt.
       */

      // Prevent submit of empty search form
      $form.on('submit', function(e) {
        if ($form.find('.tx-solr-suggest').val() === '') {
          e.preventDefault()
          $form.find('.tx-solr-suggest').focus()
        }
      })

      // Fix local undefined
      if (!$form.devbridgeAutocomplete) return

      $form
        .find('.tx-solr-suggest')
        .devbridgeAutocomplete({
          serviceUrl: $form.data('suggest'),
          dataType: 'json',
          ajaxSettings: {
            json: 'tx_solr[callback]',
          },
          paramName: 'tx_solr[queryString]',
          groupBy: 'category',
          maxHeight: 1000,
          appendTo: $formAutoComplete,
          autoSelectFirst: false,
          triggerSelectOnValidInput: false,
          width: $searchBox.outerWidth() * 0.66,
          onSelect: function(suggestion) {
            // go to link when selecting found result
            if (suggestion.data.link) {
              // Open youtube in overlay
              if (suggestion.data.link.indexOf('https://www.youtube.com') === 0) {
                // openVideoOverlay(suggestion.data.link)
              } else {
                location.href = suggestion.data.link
              }
              // else trigger form submit (do search)
            } else {
              $form.trigger('submit')
            }
          },
          transformResult: function(response) {
            if (!response.suggestions) {
              let $announcer = $('#search-suggestion-announcer')
              if ($announcer.length === 0) {
                $announcer = $(
                  '<div id="search-suggestion-announcer" class="visually-hidden" aria-live="polite"></div>'
                )
                $('body').append($announcer)
              }
              $announcer.text('Keine Vorschläge gefunden.')
              return { suggestions: [] }
            }
            var firstSuggestion,
              result = {
                suggestions: $.map(response.suggestions, function(count, suggestion) {
                  if (!firstSuggestion) firstSuggestion = suggestion
                  return { value: suggestion, data: { category: 'suggestion', count: count } }
                }),
              }

            $.each(response.documents, function(key, value) {
              var dataObject = value

              var defaultGroup = $form.data('suggest-header')
                ? $form.data('suggest-header')
                : 'Top results'
              dataObject.category = defaultGroup

              // if a group is set we try to get a label
              if (dataObject.group) {
                dataObject.category = $form.data('suggest-header-' + dataObject.group)
                  ? $form.data('suggest-header-' + dataObject.group)
                  : dataObject.group
              }

              result.suggestions.push({
                value: firstSuggestion,
                data: dataObject,
              })
            })

            let $announcer = $('#search-suggestion-announcer')
            if ($announcer.length === 0) {
              $announcer = $(
                '<div id="search-suggestion-announcer" class="visually-hidden" aria-live="polite"></div>'
              )
              $('body').append($announcer)
            }
            if (result.suggestions.length > 0) {
              $announcer.text(
                result.suggestions.length +
                  ' Vorschläge verfügbar. Nutzen Sie die Pfeiltasten zur Auswahl.'
              )
            } else {
              $announcer.text('Keine Vorschläge gefunden.')
            }

            return result
          },
          beforeRender: function(container) {
            // remove first group header
            container.find('.autocomplete-group:first').remove()
            container.addClass('tx-solr-autosuggest')

            /*
             * Rollen der Liste. Hier und nicht einmalig beim Initialisieren, weil die
             * Bibliothek den Inhalt des Containers bei jedem Tastendruck neu aufbaut.
             *
             * aria-activedescendant fehlt bewusst. Die Bibliothek bietet dafuer keinen
             * Haken; es ginge nur, indem man ihre Prototyp-Methode activate umschliesst.
             * Solange es fehlt, bleibt beim Durchsteppen mit den Pfeiltasten offen,
             * welcher Eintrag gerade aktiv ist. Die Anzahl sagt der Announcer an.
             */
            if (rollenAktiv) {
              // Die Bibliothek erzeugt diesen Container einmal und befuellt ihn neu.
              // Die id bekommt genau er, denn er ist die Listbox.
              if (!container.attr('id')) {
                vorschlaglisteNummer += 1
                container.attr('id', 'tx-solr-vorschlaege-' + vorschlaglisteNummer)
              }
              container.attr('role', 'listbox')
              container.find('.autocomplete-suggestion').attr('role', 'option')
              // Gruppenueberschriften sind Beschriftung, kein auswaehlbarer Eintrag.
              container.find('.autocomplete-group').attr('role', 'presentation')
              $eingabefeld.attr({
                'aria-controls': container.attr('id'),
                'aria-expanded': 'true',
              })
            }

            // add active class to container
            $searchBox
              .parent()
              .addClass('autocomplete-active')
              .fadeIn()
          },
          onHide: function() {
            // Zugeklappt muss das Feld das auch melden, sonst behauptet es dauerhaft
            // eine offene Liste. aria-controls bleibt stehen, der Container existiert
            // weiter, er ist nur leer.
            if (rollenAktiv) {
              $eingabefeld.attr('aria-expanded', 'false')
            }
          },
          formatResult: function(suggestion, currentValue) {
            // Do not replace anything if there current value is empty
            if (!currentValue) {
              return suggestion.value
            }
            var pattern = '(' + $.Autocomplete.utils.escapeRegExChars(currentValue.trim()) + ')'
            // normal suggestion
            if (suggestion.data.category === 'suggestion') {
              return suggestion.value
                .replace(new RegExp(pattern, 'gi'), '<strong>$1</strong>')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/&lt;(\/?strong)&gt;/g, '<$1>')

              // results
            } else {
              var title = suggestion.data.title
                .replace(new RegExp(pattern, 'gi'), '<em>$1</em>')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/&lt;(\/?em)&gt;/g, '<$1>')

              return (
                '<div class="' +
                suggestion.data.type +
                '">' +
                (suggestion.data.previewImage
                  ? '<figure ' +
                    (suggestion.data.hasVideo ? 'class="hasVideo"' : '') +
                    '><img src="' +
                    suggestion.data.previewImage +
                    '" /></figure>'
                  : '') +
                '<a href="' +
                suggestion.data.link +
                '" class="internal-link">' +
                title +
                '</a>' +
                '</div>'
              )
            }
          },
        })
        .on('blur', function() {
          $searchBox.parent().removeClass('autocomplete-active')
          var $box = $(this)
          setTimeout(function() {
            $box.devbridgeAutocomplete('hide')
          }, 200)
        })
    })
  }
}

export default SearchOverlay
